// @core/api/endpoints/secret/generate_root.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CertificateResponse,
  GenerateRootRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Generate root CA
 * Generates a new self-signed root CA certificate and private key. The private key is stored internally and never exposed. This is typically done once per PKI engine.
 */
export async function GenerateRoot(
  engine_id: string,
  data: GenerateRootRequest,
  options?: RequestOptions
): Promise<CertificateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/root/generate`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<CertificateResponse>(requestPath, data, requestOptions);
}
